export default "__VITE_ASSET__CpXozLP___"